import { defineStore } from "pinia";
import _ from "lodash";
import * as storeHelper from "@/shared/storeHelper";
import {
  CitizenshipType,
  EmploymentCategory,
  FetchState,
  UserDiscretionaryData,
  UserDiscretionaryDataState
} from "@/shared/types";
import { getUserDiscretionaryData, updateUserDiscretionaryData } from "@/shared/api/userService";

export const initialState: UserDiscretionaryDataState = {
  fetchState: FetchState.Uninitialized,
  discretionaryData: {
    citizenship: CitizenshipType.Unknown,
    citizenshipCountry: "",
    employmentCategory: EmploymentCategory.Unknown,
    employerName: "",
    jobTitle: ""
  }
};

export const useUserDiscretionaryDataStore = defineStore("userDiscretionaryData", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    getData () {
      this.discretionaryData = _.cloneDeep(initialState.discretionaryData);
      this.fetchState = FetchState.Loading;

      getUserDiscretionaryData()
        .then(response => {
          this.discretionaryData = response.data;
          this.fetchState = FetchState.Loaded;
        })
        .catch(error => {
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    },
    updateData (data: UserDiscretionaryData) {
      return updateUserDiscretionaryData(data)
        .catch(error => {
          return storeHelper.handleError({ error, rethrow: true });
        });
    }
  }
});
